import { queryOptions, useQuery } from '@tanstack/react-query';

import { getApiClient } from '@cast/api-client';

const DISCOUNTS_LIST_QUERY_KEY = 'discounts-list';

export const getDiscountsQueryKey = () => [DISCOUNTS_LIST_QUERY_KEY] as const;

type DiscountsQueryArgs = { enabled?: boolean; pageLimit?: string };

const getDiscountsQueryOptions = ({
  enabled = true,
  pageLimit = '9999',
}: DiscountsQueryArgs = {}) =>
  queryOptions({
    queryKey: getDiscountsQueryKey(),
    queryFn: () =>
      getApiClient()
        .discounts.listDiscounts({ pageLimit })
        .then(({ data }) => data.discounts),
    enabled,
  });

export const useDiscountsQuery = (args: DiscountsQueryArgs = {}) => {
  return useQuery(getDiscountsQueryOptions(args));
};
